<template>
  <div>
    <!-- <Sidebar /> -->
    <Header :headerType="2" ></Header>
    <hr style="padding:0px; margin:0px">
    <!-- <company-menu/> -->
    <main class="page-with-sidebar">
      <menu-profile></menu-profile>
      <slot></slot>
      
    </main>
    <Footer :footerType="2" />
  </div>
</template>

<script>

import MenuProfile from '../modules/company/components/MenuProfile.vue';
import sessionMixin from '../mixins/sessionMixin.js'
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

export default {
  mixins: [sessionMixin],
  components: {
    Header,
    MenuProfile,
    // Sidebar,
    Footer,
    // CompanyMenu,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" >
@import "../scss/reset.scss";
@import "../scss/base.scss";
@import "../scss/form.scss";
@import "../css/mobile.css";

.container-fluid-mobile {
  padding: 0px;
  /* background-color: #fff; */
}

.page-with-sidebar {
    display: grid;
    grid-template-columns:  minmax(150px, 25%) 1fr;
    margin-top: 0px !important;
    // height: 100vh;
}

@media only screen and (max-width: 600px) {
  main {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .page-with-sidebar {
    grid-template-rows: auto 1fr;
    grid-template-columns: none;
    // height: 100vh;
  }
}
</style>
